export const PAYMENT_INFO_REQUESTED = 'payment info read requested'
export const PAYMENT_INFO_SUCCEEDED = 'payment info read succeeded'
export const PAYMENT_INFO_FAILED = 'payment info read failed'

// ==============read================
export const paymentPlansReadRequested = () => ({
    type: PAYMENT_INFO_REQUESTED
})
export const paymentPlansReadSucceeded = (payload) => ({
    type: PAYMENT_INFO_SUCCEEDED,
    payload: payload
})



// WEBPACK FOOTER //
// ./src/model/Payment/actions.js